import React from "react";

const CrossIcon = ({ color = "#5D5D5D" }) => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.78858 1.90841L6.50559 5.19141L9.78858 8.4744C9.96272 8.64854 10.0606 8.88473 10.0606 9.131C10.0606 9.37727 9.96272 9.61346 9.78858 9.7876C9.61444 9.96174 9.37826 10.0596 9.13198 10.0596C8.88571 10.0596 8.64953 9.96174 8.47538 9.7876L5.19239 6.5046L1.90939 9.7876C1.73525 9.96174 1.49907 10.0596 1.25279 10.0596C1.00652 10.0596 0.770335 9.96174 0.596195 9.7876C0.422054 9.61346 0.324222 9.37727 0.324222 9.131C0.324222 8.88473 0.422054 8.64854 0.596195 8.4744L3.87919 5.19141L0.596194 1.90841C0.422053 1.73427 0.324222 1.49808 0.324222 1.25181C0.324222 1.00554 0.422053 0.769353 0.596194 0.595212C0.770335 0.421071 1.00652 0.32324 1.25279 0.32324C1.49907 0.32324 1.73525 0.421071 1.90939 0.595212L5.19239 3.87821L8.47538 0.595212C8.64953 0.421071 8.88571 0.32324 9.13198 0.32324C9.37826 0.32324 9.61444 0.421072 9.78858 0.595213C9.96272 0.769354 10.0606 1.00554 10.0606 1.25181C10.0606 1.49808 9.96272 1.73427 9.78858 1.90841Z"
        fill="#B1B1B1"
      />
    </svg>
  );
};

export default CrossIcon;
